import { useMemo } from "react";
import { useDeepMemoize } from "./useDeepMemoize";
export var useDeepMemo = function (factory, dependencies) {
  var depsMemo = useDeepMemoize(dependencies);
  return useMemo(factory, depsMemo);
};